import type { ChatMessage } from "../modules/teams/types.ts";

/**
 * The subset of a chat's messages the signed-in user may delete: their own
 * real messages that aren't already deleted. Kept in its own dependency-free
 * file so the "never touch someone else's message" rule is unit-tested without
 * pulling in the Graph/auth chain.
 */
export function ownDeletableMessages(
    messages: readonly ChatMessage[],
    selfUserId: string | undefined
): ChatMessage[] {
    if (!selfUserId) {
        return [];
    }
    return messages.filter(
        (m) => m.messageType === "message" && !m.deletedDateTime && m.from?.user?.id === selfUserId
    );
}
